
<template>
	<div class="loadItem">
		<div class="loadHead">
			<div class="title">
				<div class="text">PaperWork</div>
				<button @click="onGuide" type="button" class="mainBtn mainBtn-text">
          <span class="btnIco"><svg-sprite icon-id="attention" width="20" height="20"></svg-sprite></span>
				</button>
			</div>
			<div class="contract_btn">
				<button @click="onAddItem" type="button" class="mainBtn mainBtn-text" :disabled="load.ppw_date">
          <span class="btnIco"><svg-sprite icon-id="generateFile" width="20" height="20"></svg-sprite></span>
					<span class="btnText">Generate file</span>
				</button>
			</div>
		</div>
		<div class="loadMain ppwField" v-if="load.ppw_date">
			<field
					margin="0"
					label="Generated date"
					:setInputValue="load.ppw_date"
					is-readonly
			></field>
			<field
					margin="0"
					label="Generated by"
					:setInputValue="load.ppw_created_by"
					is-readonly
			></field>
			<field
					margin="0"
					label="PPW file"
					:setInputValue="fileName"
					iconGap="10px"
			>
				<template slot="additionalElements">
					<field-custom-icon-buttons
							v-for="(button, index) in customIconButtons"
							:key="button.icon"
							:index="index"
							:button="button"
							:item="load.billing"
							@updateCustomIconButton="onCustomIconButton($event, 'filePPW')"
					></field-custom-icon-buttons>
				</template>
			</field>
		</div>
	</div>
</template>
<script>
import FieldCustomIconButtons from "@/shared/Field/FieldCustomIconButtons.vue";

import { PAGE } from "@/constants/constants";

export default {
	name: "PaperWork",
	components: {
		FieldCustomIconButtons
	},
	props: {
		load: Object,
	},
	computed: {
		fileName() {
			if (this.load.ppw_file) return this.load.ppw_file.split('/').pop();
			return null;
		},
	},
	data() {
		return {
			customIconButtons: [
				{
					icon: "icon_send",
				},
				{
					icon: "icon_view",
				},
				{
					icon: "icon_download",
				},
				{
					icon: "deleteItem",
				},
			],
		};
	},
	methods: {
		onGuide() {
			this.$emit('updateGuide', PAGE.TRIP_PAPER_WORK);
		},
		onAddItem() {
			this.$emit('updateAddItem', this.flag);
		},
		onCustomIconButton(btn, key) {
			this.$emit('updateCustomIconButton', { key, btn });
		},
	},
};
</script>
<style lang="scss">
.loadMain {
	.pagination {
		padding: 20px 0 10px;
	}
}
</style>
<style scoped lang="scss">
@import "../loadItem";
.loadMain {
	&.ppwField {
		display: grid;
		grid-gap: 10px;
		grid-template-columns: 1fr 1fr 1fr;
	}
}
</style>
